import { mapState } from 'vuex';
import mhhr from '../MHHR/mhhr';
export default {
	computed: {
		...mapState('newsModule', ['currentPage'])
	},
	components: {
		mhhr
	},
	mounted() {
		this.$scrollTo(this.$refs['highlighted-news-top']);
	}
};
